// Backend API client for SolveIt (subject-aware)
import axios from 'axios';

// Same origin in production (the Worker serves /api); local dev points at `wrangler dev`.
const BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const http = axios.create({ baseURL: BASE, timeout: 30000 });

export const api = {
  stats:        () => http.get('/stats').then(r => r.data),
  listSubjects: () => http.get('/subjects').then(r => r.data),
  listExams:    () => http.get('/exams').then(r => r.data),
  listSections: (subject = 'math') => http.get('/sections', { params: { subject } }).then(r => r.data),
  listTopics:   (sectionSlug, subject = 'math') => http.get(`/sections/${sectionSlug}/topics`, { params: { subject } }).then(r => r.data),
  listQuestions: (params) => http.get('/questions', { params }).then(r => r.data),
  getQuestion:  (id) => http.get(`/questions/${id}`).then(r => r.data),
};

export default api;
